// extracted by mini-css-extract-plugin
module.exports = {"smallRarityImage":"SmallRarityCard_smallRarityImage__3SK5g"};